import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { PrivateRoute } from '../../../../../utils/route-auth';
import { PERMISSION } from '../../../../../constants/permission';

import asyncRoute from '../../../../../helpers/hoc/asyncRoute';
import routes from '../../../../../routes';

const List = asyncRoute(() => import('./List'));

const Advertiser = (props) => {
    // console.log(props, "AGENCY");
    return (
        <Switch>
            <Route exact path={`${props.match.path}`} component={List} />
        </Switch>
    )
};


export default Advertiser;
